import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-salinity-vertical',
  standalone: false,
  templateUrl: './salinity-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class SalinityVerticalComponent {
@Input() salinityTest:any
}
